export default __webpack_public_path__ + "static/media/plain-sticker-N.1bf3902b.png";